<template>
  <tolgee-provider>
    <!-- <tolgee-selector></tolgee-selector> -->
    <div class="verification-wrapper">
      <div class="verification-wrapper__content">
        <router-view />
      </div>
      <div class="verification-wrapper__shape"></div>
    </div>
  </tolgee-provider>
</template>

<script setup lang="ts">
import { TolgeeProvider } from '@tolgee/vue'
import { useTolgee } from '@tolgee/vue'

const tolgee = useTolgee(['language'])

// Components
// import TolgeeSelector from './components/TolgeeSelector/TolgeeSelector.vue'
import { onMounted } from 'vue'

onMounted(() => {
  console.log('META: ', import.meta.env, tolgee)
})
</script>

<style lang="scss">
.verification-wrapper {
  display: flex;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;

  &__content {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    padding-top: 80px;
    padding-bottom: 80px;
  }

  &__shape {
    height: 100%;
    flex-shrink: 0;
    width: 673px;
    background-image: url('@/assets/images/shape-background.jpg');
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
  }

  @media screen and (max-width: 1365px) {
    &__shape {
      display: none;
    }
  }

  @media screen and (max-width: 743px) {
    &__content {
      padding: 0;
    }
  }
}

.invalid {
  // border-color: var(--color-text-accent) !important;
  &--element-border {
    border-radius: 4px;
    border: 1px var(--color-text-accent) solid !important;
  }

  &--text {
    color: var(--color-icon-accent-dangerous) !important;
  }

  &--card-border {
    border-color: var(--color-icon-accent-dangerous) !important;
  }
}
</style>
